
export function WelcomeFooter() {
  return (
    <footer className="bg-secondary mt-8">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 py-12">
        {/* Help section */}
        <div className="text-center mb-10">
          <h3 className="font-display text-lg font-semibold text-white mb-2">Need Help Before Your Call?</h3>
          <p className="text-gray-400 text-sm mb-6 max-w-md mx-auto">
            Our team is here for you. Reach out anytime and we&apos;ll get back to you within the hour.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="mailto:support@dino-nuggets.com"
              className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-full px-5 py-2.5 text-sm text-white transition-colors cursor-pointer"
            >
              <i className="ri-mail-line text-primary"></i>
              support@dino-nuggets.com
            </a>
            <a
              href="tel:+15867899699"
              className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-full px-5 py-2.5 text-sm text-white transition-colors cursor-pointer"
            >
              <i className="ri-phone-line text-primary"></i>
              (586) 789-9699
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <span className="text-primary font-extrabold text-lg font-nunito">Dino Nuggets</span>
            </div>
            <div className="flex gap-6 text-xs">
              <a href="/privacy-policy" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="/terms-of-service" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                Terms of Service
              </a>
              <span className="text-gray-400">Dino Nuggets</span>
            </div>
          </div>
          <p className="text-center sm:text-left text-xs text-gray-500 mt-4">
            &copy; 2025 Dino Nuggets. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
